// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface INotionalDetailsResponseDto
 */
export interface INotionalDetailsResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof INotionalDetailsResponseDto
     */
    plan_year_valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof INotionalDetailsResponseDto
     */
    plan_year_valid_to?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof INotionalDetailsResponseDto
     */
    is_carded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof INotionalDetailsResponseDto
     */
    available_balance?: string;
    /**
     * 
     * @type {string}
     * @memberof INotionalDetailsResponseDto
     */
    election_max?: string;
    /**
     * 
     * @type {string}
     * @memberof INotionalDetailsResponseDto
     */
    funding_method?: INotionalDetailsResponseDtoFundingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof INotionalDetailsResponseDto
     */
    terminated_employees_runout?: string;
    /**
     * 
     * @type {Date}
     * @memberof INotionalDetailsResponseDto
     */
    runout_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof INotionalDetailsResponseDto
     */
    runout_days_until?: number;
    /**
     * 
     * @type {Date}
     * @memberof INotionalDetailsResponseDto
     */
    grace_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof INotionalDetailsResponseDto
     */
    grace_days_until?: number;
    /**
     * 
     * @type {Date}
     * @memberof INotionalDetailsResponseDto
     */
    rollover_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof INotionalDetailsResponseDto
     */
    rollover_days_until?: number;
    /**
     * 
     * @type {string}
     * @memberof INotionalDetailsResponseDto
     */
    rollover_min_amount?: string;
    /**
     * 
     * @type {string}
     * @memberof INotionalDetailsResponseDto
     */
    rollover_max_amount?: string;
    /**
     * 
     * @type {Date}
     * @memberof INotionalDetailsResponseDto
     */
    forfeiture_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof INotionalDetailsResponseDto
     */
    forfeiture_days_until?: number;
}

/**
* @export
* @enum {string}
*/
export enum INotionalDetailsResponseDtoFundingMethodEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}


/**
 * Check if a given object implements the INotionalDetailsResponseDto interface.
 */
export function instanceOfINotionalDetailsResponseDto(value: object): value is INotionalDetailsResponseDto {
    return true;
}

export function INotionalDetailsResponseDtoFromJSON(json: any): INotionalDetailsResponseDto {
    return INotionalDetailsResponseDtoFromJSONTyped(json, false);
}

export function INotionalDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): INotionalDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_year_valid_from': json['plan_year_valid_from'] == null ? undefined : (new Date(json['plan_year_valid_from'])),
        'plan_year_valid_to': json['plan_year_valid_to'] == null ? undefined : (new Date(json['plan_year_valid_to'])),
        'is_carded': json['is_carded'] == null ? undefined : json['is_carded'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'election_max': json['election_max'] == null ? undefined : json['election_max'],
        'funding_method': json['funding_method'] == null ? undefined : json['funding_method'],
        'terminated_employees_runout': json['terminated_employees_runout'] == null ? undefined : json['terminated_employees_runout'],
        'runout_date': json['runout_date'] == null ? undefined : (new Date(json['runout_date'])),
        'runout_days_until': json['runout_days_until'] == null ? undefined : json['runout_days_until'],
        'grace_date': json['grace_date'] == null ? undefined : (new Date(json['grace_date'])),
        'grace_days_until': json['grace_days_until'] == null ? undefined : json['grace_days_until'],
        'rollover_date': json['rollover_date'] == null ? undefined : (new Date(json['rollover_date'])),
        'rollover_days_until': json['rollover_days_until'] == null ? undefined : json['rollover_days_until'],
        'rollover_min_amount': json['rollover_min_amount'] == null ? undefined : json['rollover_min_amount'],
        'rollover_max_amount': json['rollover_max_amount'] == null ? undefined : json['rollover_max_amount'],
        'forfeiture_date': json['forfeiture_date'] == null ? undefined : (new Date(json['forfeiture_date'])),
        'forfeiture_days_until': json['forfeiture_days_until'] == null ? undefined : json['forfeiture_days_until'],
    };
}

export function INotionalDetailsResponseDtoToJSON(json: any): INotionalDetailsResponseDto {
    return INotionalDetailsResponseDtoToJSONTyped(json, false);
}

export function INotionalDetailsResponseDtoToJSONTyped(value?: INotionalDetailsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_year_valid_from': value['plan_year_valid_from'] == null ? undefined : ((value['plan_year_valid_from']).toISOString().substring(0,10)),
        'plan_year_valid_to': value['plan_year_valid_to'] == null ? undefined : ((value['plan_year_valid_to']).toISOString().substring(0,10)),
        'is_carded': value['is_carded'],
        'available_balance': value['available_balance'],
        'election_max': value['election_max'],
        'funding_method': value['funding_method'],
        'terminated_employees_runout': value['terminated_employees_runout'],
        'runout_date': value['runout_date'] == null ? undefined : ((value['runout_date']).toISOString().substring(0,10)),
        'runout_days_until': value['runout_days_until'],
        'grace_date': value['grace_date'] == null ? undefined : ((value['grace_date']).toISOString().substring(0,10)),
        'grace_days_until': value['grace_days_until'],
        'rollover_date': value['rollover_date'] == null ? undefined : ((value['rollover_date']).toISOString().substring(0,10)),
        'rollover_days_until': value['rollover_days_until'],
        'rollover_min_amount': value['rollover_min_amount'],
        'rollover_max_amount': value['rollover_max_amount'],
        'forfeiture_date': value['forfeiture_date'] == null ? undefined : ((value['forfeiture_date']).toISOString().substring(0,10)),
        'forfeiture_days_until': value['forfeiture_days_until'],
    };
}

